// extracted by mini-css-extract-plugin
export default {"container":"styles_container__F6uGh","body":"styles_body__hOdtm","blueline":"styles_blueline__uq9C1","botaoSalvar":"styles_botaoSalvar__mmmUx"};